function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m240 0h32v144h-32zm0 0",
  fill: "#4dd0e1"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m240 368h32v144h-32zm0 0",
  fill: "#4dd0e1"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#42a5f5"
}, React.createElement("path", {
  d: "m128 192h384v32h-384zm0 0"
}), React.createElement("path", {
  d: "m0 192h32v32h-32zm0 0"
}), React.createElement("path", {
  d: "m64 192h32v32h-32zm0 0"
}), React.createElement("path", {
  d: "m0 288h384v32h-384zm0 0"
}), React.createElement("path", {
  d: "m480 288h32v32h-32zm0 0"
}), React.createElement("path", {
  d: "m416 288h32v32h-32zm0 0"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m256.527344 164.558594-76.925782-62.046875c-6.882812-5.566407-7.96875-15.632813-2.417968-22.511719 5.550781-6.878906 15.617187-7.953125 22.496094-2.398438l56.847656 45.855469 56.847656-45.855469c6.882812-5.554687 16.945312-4.464843 22.496094 2.398438 5.554687 6.878906 4.464844 16.960938-2.414063 22.496094zm0 0",
  fill: "#80deea"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m313.375 434.414062-56.847656-45.855468-56.847656 45.855468c-6.878907 5.554688-16.945313 4.464844-22.496094-2.398437-5.550782-6.878906-4.464844-16.960937 2.402344-22.496094l76.925781-62.046875 76.945312 62.046875c6.878907 5.550781 7.949219 15.617188 2.414063 22.496094-5.535156 6.863281-15.613282 7.9375-22.496094 2.398437zm0 0",
  fill: "#80deea"
});

var SvgCollision = function SvgCollision(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCollision, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/collision.35d5d16e.svg";
export { ForwardRef as ReactComponent };